import { defineStore } from 'pinia';

export default defineStore('orginalQuery', {
  state: () => ({
    originalQuery: {},
  }),
  getters: {
    getOriginalQuery: (state) => state.originalQuery,
  },
  actions: {
    loadOriginalQuery() {
      const { originalQuery } = window;
      this.originalQuery = originalQuery;
    },
  },
});
